import React from "react";
import "../App.css";
//import {InfiniteLoading} from 'react-simple-infinite-loading'

class Download extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            postsData: [],
            lastVisible: null,
            finished: false,
            loading: false,
        }
    }

    render() { 
        return ( 
            <div className="content-home" style={{backgroundColor:"#ECEFF1", display:"flex", justifyContent:"center", minHeight:"100vh", marginTop:20}}>
                <div>
                    <h3>Download Richless</h3>
                    <h3>We're currently developing to IOS</h3>
                    <a href="https://play.google.com/store/apps/details?id=com.godapp.richless.app">Here's the link to google play</a>
                </div>
            </div>
        );
    }
}
 
export default Download;
